import { IFBCompanyFeatureConf } from '@interfaces';
import keyBy from 'lodash-es/keyBy';

/**
 * This is ES6 implementation of https://www.npmjs.com/package/angular-feature-flags
 */

class FeatureFlags {
  private flagsByKey: { [key: string]: IFBCompanyFeatureConf } = {};

  isOn(key: string) {
    return !!this.flagsByKey[key]?.active;
  }

  set(newFlags: IFBCompanyFeatureConf[]) {
    this.flagsByKey = {
      ...this.flagsByKey,
      ...keyBy(newFlags, (el: IFBCompanyFeatureConf) => el.key)
    };
  }

  setFeature(key: string, value: boolean) {
    this.flagsByKey[key] = { active: value, description: key, key, name: key };
  }
}

export const featureFlags = new FeatureFlags();
